import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian honeycomb-bg flex items-center justify-center p-5">
      <div className="w-full max-w-sm bg-carbon border border-white/10 rounded-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-sm bg-honey/15 flex items-center justify-center">
            <Lock className="w-5 h-5 text-honey" />
          </div>
          <div>
            <h1 className="text-xl font-display font-bold text-white">HoneyBee Admin</h1>
            <p className="text-xs text-zinc-500">Lead dashboard login</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-black/40 border border-white/15 rounded-sm px-4 py-3 text-white placeholder:text-zinc-500 focus:outline-none focus:border-honey" />
          <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-black/40 border border-white/15 rounded-sm px-4 py-3 text-white placeholder:text-zinc-500 focus:outline-none focus:border-honey" />
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-honey text-white font-bold py-3 rounded-sm flex items-center justify-center gap-2 hover:bg-honey-600 transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign In"}
          </button>
        </form>
        <a href="/" className="block text-center text-xs text-zinc-500 hover:text-honey mt-5 transition-colors">← Back to website</a>
      </div>
    </div>
  );
}
